'use strict';

export default class ForgotPasswordController {
  user = {
    email: ''
  };

  submitted = false;
  sending = false;
  sent = false;
  error = '';
  redirectPromise = null;

  /*@ngInject*/
  constructor($http, baseConfigService, $state, $timeout, $scope) {
    this.$http = $http;
    this.baseConfigService = baseConfigService;
    this.$state = $state;
    this.$timeout = $timeout;

    $scope.$on('$destroy', () => {
      if (this.redirectPromise) {
        this.$timeout.cancel(this.redirectPromise);
      }
    });
  }

  submit(form) {
    if (this.sending) {
      return;
    }

    this.submitted = true;
    this.error = '';

    if (!form.$valid) {
      return;
    }

    this.sending = true;

    const adminBaseURL = this.baseConfigService.getAdminBaseURL();
    const resetCallbackUrl = `${window.location.origin}/reset-password`;

    this.$http.post(`${adminBaseURL}/email/sendReset`, {
      to_email: this.user.email,
      reply_to_email: 'trodriguez@bayareametro.gov',
      subject: 'Reset Your Password',
      reset_callback_url: resetCallbackUrl
    }, {
      skipAuthRedirect: true
    })
      .then(() => {
        this.sent = true;
        this.sending = false;
        this.scheduleLoginRedirect();
      })
      .catch(err => {
        this.sending = false;
        // Still show sent=true to avoid revealing whether an account exists
        this.sent = true;
        this.scheduleLoginRedirect();
      });
  }

  scheduleLoginRedirect() {
    if (this.redirectPromise) {
      this.$timeout.cancel(this.redirectPromise);
    }

    this.redirectPromise = this.$timeout(() => {
      this.$state.go('main');
    }, 7000);
  }
}



// WEBPACK FOOTER //
// ./client/app/account/forgot-password/forgot-password.controller.js